import { render, staticRenderFns } from "./Procurement_items.vue?vue&type=template&id=2439073d&scoped=true&"
import script from "./Procurement_items.vue?vue&type=script&lang=js&"
export * from "./Procurement_items.vue?vue&type=script&lang=js&"
import style0 from "./Procurement_items.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Procurement_items.vue?vue&type=style&index=1&id=2439073d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439073d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VIcon,VRow})
